import { type FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";

import { type Project } from "../../../graphql.js";

export interface IProjectGroupCardProps extends GridCard {
  project: Project;
}

const ProjectGroupCard: FC<IProjectGroupCardProps> = ({ project }) => {
  if (!project?.userGroup) {
    return null;
  }

  return (
    <Card key="project-group-info-card" title={`User Group Information`}>
      <CardRowSimple label={"Name"} value={project.userGroup.name} />
      <CardRowSimple label={"Description"} value={project.userGroup.description} />
    </Card>
  );
};

export { ProjectGroupCard };
